import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { CommonMethodService } from '../../common/commonMethod.service';
import { MessagingService } from '../../services/messaging.service';
import { ChangePasswordModel } from '../../models/changePassword.model';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: 'forgetPassword.component.html',
  providers: [UserService, CommonMethodService]
})
export class ForgetPasswordComponent implements OnInit, OnDestroy {

  subscribe: Array<Subscription> = [];
  constructor(private toaster: ToastrService, private route: Router, private userService: UserService,
    private commonMethod: CommonMethodService, private messagingService: MessagingService) { }

  loginForm: FormGroup;
  fcmToken: string;
  loader: boolean = false;
  option: boolean = false;
  username: string;
  email: string;

  ngOnInit(): void {
  }

  onChangeOption(value) {
     if (value === 'email') {
        this.option = true;
     } else {
      this.option = false;
     }
     this.username = null;
     this.email = null;
  }

  // onSubmit(): void {
  //   if (this.loginForm.invalid) {
  //     return;
  //   }
  //   this.fcmToken = '';
  //   this.fcmToken = this.messagingService.requestPermission();
  //   if (this.fcmToken === undefined || this.fcmToken === '') {
  //     this.fcmToken = sessionStorage.getItem('fcmToken');
  //   }
  //   const deatils: LoginCredentialModel = this.loginForm.value;
  //   deatils.fcmToken = this.fcmToken;
  //   this.loader = true;
  //   this.subscribe.push(this.loginService.login(deatils).subscribe(
  //     data => {
  //       this.loader = false;
  //       const wrapper: LoginModel = JSON.parse(JSON.stringify(data));
  //       sessionStorage.clear();
  //       if ( wrapper.role === 'DEVICE_ADMIN' ) {
  //         this.toaster.error('You do not have permission to login.');
  //         return false;
  //       }
  //       sessionStorage.setItem('token', wrapper.id_token);
  //       localStorage.setItem('name', this.loginForm.value.username);
  //       sessionStorage.setItem('accountName', wrapper.accountName);
  //       sessionStorage.setItem('username', this.loginForm.value.username);
  //       sessionStorage.setItem('type', wrapper.type);
  //       sessionStorage.setItem('role', wrapper.role);
  //       sessionStorage.setItem('dialingCode', wrapper.dialingCode);
  //       sessionStorage.setItem('county', wrapper.county);
  //       sessionStorage.setItem('country', wrapper.country);

  //       if ( wrapper.role === 'RESIDENT_ADMIN' ) {
  //         sessionStorage.setItem('residentId', wrapper.residentId.toString());
  //         sessionStorage.setItem('flatId', wrapper.flatId.toString());
  //         sessionStorage.setItem('hostCheckOut', wrapper.hostCheckOut.toString());
  //       }
  //       if ( wrapper.accountId !== 0) {
  //         sessionStorage.setItem('accountId', wrapper.accountId.toString());
  //       }
  //       if ( wrapper.role === 'EMPLOYEE_ADMIN' ) {
  //         sessionStorage.setItem('employeeId', wrapper.employeeId.toString());
  //         sessionStorage.setItem('hostCheckOut', wrapper.hostCheckOut.toString());
  //       }
  //       this.route.navigate(['/home/dashboard']);
  //       this.toaster.success('You are successfully logged in');
  //     }, error => {
  //       this.loader = false;
  //       this.commonMethod.returnErrorMessage(error);
  //       sessionStorage.clear();
  //     }));
  // }

  onSubmit(): void {
    if (this.username === null || this.username === undefined || this.username === '' || this.username.trim() === '') {
      this.toaster.error('Please enter username');
      return;
    }
    if (this.username.indexOf(' ') !== -1 ) {
      this.toaster.error('Space not allowed in username');
      return;
    }
    if (this.option) {
      if (this.email === null || this.email === undefined || this.email === '' || this.email.trim() === '') {
        this.toaster.error('Please enter email');
        return;
      }
      if (this.email.indexOf(' ') !== -1 ) {
        this.toaster.error('Space not allowed in email');
        return;
      }
    }
    const details =  new ChangePasswordModel();
    details.email = this.email;
    details.username = this.username;
    this.loader = true;
    if (this.option) {
      details.type = 'reset';
    } else {
      details.type = 'request';
    }
    this.subscribe.push(this.userService.generatePasswordLink(details).subscribe(
      data => {
        const wrapper  = JSON.parse(JSON.stringify(data));
        this.toaster.success(wrapper.result);
        sessionStorage.clear();
        this.username = null;
        this.email = null;
        this.loader = false;
        this.route.navigate(['/']);
      }, error => {
        this.loader = false;
        this.commonMethod.returnErrorMessage(error);
      }));

  }

  // forgetPassword(): void {
  //   this.route.navigate(['/home/adminstrator/forget-password']);
  // }

  ngOnDestroy(): void {
    this.subscribe.forEach(destroyExistingValue => {
      destroyExistingValue.unsubscribe();
    });
  }
}
